export default {
  warningList: [
    '投资者不应只根据艾德证券期货网页及艾德一站通应用程式内容而作出任何投资决定。投资者作出投资决定前应先参阅有关基金销售文件及细阅基金公司所刊发有关基金资料单张上列明的基金特色以及有关风险。您可在艾德一站通应用程式内或相关基金公司网页查阅基金销售文件。',
    '基金乃投资产品而部份涉及金融衍生工具。投资决定是由阁下自行作出的，但阁下不应投资在该基金，除非中介人于销售该产品时已向阁下解释经考虑阁下的财务情况、 投资经验及目标后，该产品是适合阁下的。',
    '基金产品并不相等于定期存款。',
    '投资涉及风险。过去的业绩并不代表将来的表现。投资价值及基金的收入/股息可升可跌，不能保证能赚取利润。',
    '在最坏情况下， 基金价值或会大幅地少于您的投资金额（在极端的情况下，您投资的回报可能会变成没有价值）。',
    '基金的投资可能涉及广泛的市场，货币，波幅，流动性，监管及政治风险。',
    '如基金涉及投资于新兴市场，单一市场或限量地区市场或行业或小型企业，基金可能会涉及较高风险,并通常对价格变动较敏感。',
    '如基金投资于金融衍生工具，或会涉及额外的风险以及可能承受较高的波幅。',
    '如投资以外币计值，有关港元换算均属指示性，仅供参考。投资总值会以港币显示，而持有个别基金的价值则以相关货币显示。'
  ],
  applyFund: '基金账户申请',
  fundTarget: `开通基金账户前，您需要先完成风险问卷测评，以确认您的投资风险偏好。<br>
  本风险取向问卷旨在協助本公司了解阁下或阁下所代表的公司的投资目标、风险取向和风险承担，以助本公司确定合适阁下或阁下所代表的公司风险取向的投资选择。`,
  warnText: '重要提示及免责声明',
  importText: `阁下可以于填写本风险取向问卷的时候向本公司提出问题及索取独立意见。当完成本风险取向问卷并获评定风险取向及风险承担后，相关的资料会被记录于本公司并用于提供投资建议和评估该投资者是否适合相关的投资产品或服务。及以此问卷之回复更新阁下个人资料(如适用)。本公司将按照本风险取向问卷所提供资料作出评估，如其中的资料报含重大遗漏、错误或虚假陈述，本公司谨此免除就所有相关索赔、要求及诉讼承担责任。假如我们向阁下招揽销售或建议任何金融产品，该金融产品必须是我们经考虑阁下的财政状况、投资经验及投资目标后而认为合理地适合阁下的。本协议的其他条文或任何其他我们可能要求阁下签署的文件及我们可能要求阁下作出的声明概不会减损本条款的效力。`,
  toRisk: '前往测评',
  toOpenaccount: '跳过测评，直接开户',
  openStock: '请先开通证券账户后再开通基金账户',
  disclosure: '风险披露',
  agreeText: '本人已阅读及同意本',
  protocol: '基金销售服务协议',
  and: '及',
  riskProtocol: '基金交易重要风险提示',
  sureBtnText: '确认开通基金账户',
  warntextAgree: '您需要阅读并勾选相关协议才能提交',
  chooseAppropriate: '请选择适当的选项',
  riskAssess: '风险测评',
  name: '姓名：',
  idText: '身份证 / 护照号码：',
  ageError: '年龄组别不符',
  level1: '1（低风险）',
  level2: '2（低至中等风险）',
  level3: '3（中等风险）',
  level4: '4（中等至高风险）',
  level5: '5（高风险）',
  level1Text: '保守型',
  level2Text: '稳健型',
  level3Text: '平衡型',
  level4Text: '增长型',
  level5Text: '进取型',
  xing: '型',
  normal: '普通投资者',
  desText1:
    '您可选择投资于低风险的投资产品，以债券及现金为主以达到稳定回报的目的。如此一来，您要明白所收取的回报也较低。',
  desText2:
    '您可以接受低至中风险及价格波动，并有一些的投资回报。',
  desText3:
    '您可选择多元化及较均衡的股票、债券及现金投资组合。您愿意承担中等级别的风险，以便在中长期内赚取一些潜在回报。',
  desText4:
    '您可以接受高风险及价格波动，并且有资本增值的投资。',
  desText5:
    '您可选择投资于任何风险级别的衍生产品、投资基金和/或其他金融产品。您愿意承担高级别的风险，以便在中长期内得到最大的潜在回报。您知道您可能损失大部份或全部资本，您甚至可能须对资本以外的亏损作出补偿。',
  riskTitle: '风险等级',
  resultText: '评估结果',
  category: '具体类别',
  desc: '描述',
  investorType: '投资者类型',
  target: '投资目标',
  investmentPeriod: '投资年期',
  declareAssets: '申报净资产',
  derivativesKnowledge: '衍生品知识',
  reTest: '结果有误，重新测评',
  openFund: '确认结果无误',
  agreeRiskText:
    '本人同意并确认本风险取向问卷的总结能准确地形容本人或本人所代表的公司的风险取向',
  all: '共',
  specialText: '道题，已回答',
  daoti: '道题',
  Disclaimer: '免责声明',
  disclaimerText: `1.本问卷的结果是从阁下向艾德证券期货有限公司(「艾德证券期货」)提供的资料，并根据若干普遍接纳的假设及合理估算而得出。本问卷采用的方法及取值谨供说明用途。艾德证券期货对本问卷所载数据及/或所得结果的准确性或完整性并不负责或承担任何法律责任。</br>2.本问卷及所得结果谨供阁下参考，并非购买或出售任何金融产品及服务的要约或招揽、亦不应被视为投资意见或推荐。</br>3.请注意，倘若阁下未能全面披露所有或任何有关阁下的个人状况(如财务状况)、不正确、不完整或过时的数据可能影响本集团评估阁下对投资风险的态度及承受能力。如阁下的状况出现变动而可能影响本问卷中任何问题的答案，我们极力建议阁下再次填写本问卷。`,
  disclaimerText1: '1.本人/吾等谨此声明，按本人/吾等所知，本人/吾等在本文件提供的资料真确无误。本人/吾等同意，如此资料有任何变动，本人/吾等将会在合理可行情况下尽快以书面通知艾德证券期货有限公司(“艾德”)。本人/吾等同意以上的风险评估结果。本人/吾等确认，就本人提供不完整或不正确资料所导致的任何行动或遗漏，艾德概不负上任何责任。',
  disclaimerText2: '2.本问卷及测试结果仅供参考，并不构成投资建议，亦不得视为建议游说买卖任何投资产品及服务。艾德对本问卷内容及结果的准确性及完整性概不作出任何保证。极力建议客户最少每年一次或在个人状况及生重大转变时，检讨客户对投资风险的见解，以确保投资决定仍然配合对投资风险取向的态度。',
  disclaimerText3: '3. 请注意，倘若阁下未能全面披露所有或任何有关阁下的个人状况(如财务状况)、不正确、不完整或过时的数据可能影响本集团评估阁下对投资风险的态度及承受能力。如阁下的状况出现变动而可能影响本问卷中任何问题的答案，我们极力建议阁下再次填写本问卷。',
  openReview: '开户审核中',
  fivemins: '大约1-2个工作天后可开通',
  return: '返回',
  notBackInfo: '退出后，已填写信息将不保存',
  dialogTitle: '确定要退出当前页？',
  secondInfo: '本人声明，因未理解题目，或个人状况发生改变需要重新评估',
  retestTitle: '重新测评',
  totest: '去测评',
  fundsSource: '请注明资金来源(多选)',
  placeholderFundsSource: '请输入资金来源',
  infoSame: '本人确认本人其他资料并无改变，与开户时所提交的资料相同',
  notAccept: '就业情况和资金来源不匹配',
  hadVaAcount: '阁下已开通了虚拟资产账户，不支持将现有的风险等级调整为其他风险等级，如有疑问，欢迎致电+852 2655 0338 / 400 120 0068（中国内地免费热线）或电邮至cs@eddidsec.com与客户服务部联络。',
  signTitle: '请在下方白色区域内签好你的姓名，尽量占满区域',
  readSign: '已阅读，去签名',
  statement: [
    {
      zh: '为保障阁下购买投资产品的利益，艾德证券期货有限公司（“艾德”）已就阁下是否被归类为容易受损客户（“容易受损客户”）进行评估。',
      en: 'In order to protect your interests in purchasing investment products, Eddid Securities and Futures Limited (“EDDID”) has conducted an assessment on whether you are classified as a vulnerable client (“VC”) or not.'
    },
    {
      zh: '根据我们的评估，阁下被归类为容易受损客户。然而，考虑到阁下的投资经验及背景，我们将根据阁下从客户风险评估问卷（“客户风险评估问卷”）中评估获得的投资风险取向，评估阁下是否适合投资于特定投资产品（如适用）。',
      en: 'Based on our assessment, you are classified as a VC. However, in view of your investment experience and background, we will assess your suitability on investing in particular investment products (where applicable) based on your Investment Risk Profile obtained from the Risk Profiling Questionnaire (“RPQ”).'
    },
    {
      zh: '此声明书适用于所有本人/吾等属实益拥有人的账户。',
      en: 'This declaration form applies to all accounts of which I am / We are the beneficial owner.'
    },
    {
      zh: '通过在此声明书上签署，本人/吾等确认：',
      en: 'By signing on this form, I /We confirm that:'
    },
    {
      zh: '本人/吾等同意艾德将本人/吾等归类为容易受损客户；',
      en: '1.I /We agree to be treated as a VC by EDDID;'
    },
    {
      zh: '于作出投资决定时，本人在精神上有能力做出独立的投资决策，尽管考虑到本人的年龄及/或其他被视作容易受损客户的状况（包括任何明显的残疾）；',
      en: '2.I am mentally capacitated to make independent investment decisions, despite my age and/or other vulnerable conditions (including any observable disabilities) in making investment decision;'
    },
    {
      zh: '本人在此账户中所进行的投资，将按照客户风险评估问卷评估结果中获得的投资风险取向进行合适性评估；',
      en: '3.the suitability assessment for my investments transacted in this Account will be based on the Investment Risk Profile obtained from the assessment result of the RPQ;'
    },
    {
      zh: '本人将能够就可能涉及较高风险的投资产品（包括损失超过投资金额的可能性）进行交易，尽管考虑到本人的年龄及/或其他被视作容易受损客户的状况；及',
      en: '4.notwithstanding my age and/or other vulnerable conditions, I will be able to deal in investment products which may involve higher risks (including the possibility of losses exceeding the amount invested); and'
    },
    {
      zh: '本人在投资产品销售和下单过程中，无须携伴。',
      en: '5.I am not required to bring along a companion during the sales process for investment products and placing orders.'
    }
  ],
  hadGreen: '我已阅读并同意',
  hadFiveTimes: '根据我们的记录，阁下于过去30日曾完成客户风险评估问卷{number}次或以上。如果阁下对风险评估问卷的问题有任何查询，欢迎随时致电 +852 2655 0338 / 400 120 0068（中国内地免费热线） 或电邮至 cs@eddidsec.com 与客户服务部联络。',
  continueAssessment: '继续评估',
  useUpChange: '今日测试次数已用完，请明天再试。',
  haveChanges: '你今日还能测试({number})次，请谨慎作答。',
  hadAgreeCustomerDeclaration: '本人已查阅并确认',
  customerDeclaration: '《容易受损客户声明书》',
  readDeclaration: '本人/吾等已阅读本人所申请的产品资金概要、注释备忘录及其他销售资料。本人/吾等声明及同意本人/吾等完全明白并接受有关产品之特性包括但不限于潜在之风险、回报及损失。本人/吾等确定根据本人/吾等于“客户风险评估问卷”所披露之现时需要及投资风险概况，有关产品之特色及其风险级别均适合本人/吾等。',
  pleaseSign: '请签署姓名信息。',
  weWillCallyou: '我们会尽快联络阁下，与阁下进行确认及解释一般投资风险。阁下同意假如我们未能联络阁下，阁下的风险类别将会重设为「保守型」。',
  readAndSigned: '已阅读并签署',
  vulnerable: '容易受损客户声明书',
  title1: '重要提示',
  description1: [
    '本客户风险评估问卷旨在协助本公司了解阁下或阁下所代表的公司的投资目标、风险取向和风险承担，以助本公司确定适合阁下所代表的公司风险取向的投资选择。',
    '阁下确认开立帐户过程中提供的资料，包括但不限于客户风险评估问卷，均是真实、准确和有效的，能够准确、真实地反映阁下的状况、意愿、投资目标、风险偏好和风险承受能力。',
    '阁下知悉本公司将依赖最新提交的客户风险评估问卷的结果作为评估投资产品是否适合阁下的依据。阁下确认及同意，如阁下的风险等级有所变动，将有可能被限制交易某些产品 (如虚拟资产)。',
    '阁下知悉本公司会根据阁下在先前的客户风险评估问卷内所提供的资料，自动就某些问题输入答案。',
    '阁下确认及同意，如阁下知悉早前提供予本公司的讯息已过时或不再准确，未能真实、准确地反映阁下状况时, 会尽快联络客服更新帐户资料。',
    '阁下确认及同意，如本公司发现阁下的资料出现前后不一致，可以较迟者为准，并有权随时联络阁下跟进。'
  ],
  title2: '重要提示及免责声明',
  description2: '阁下可以于填写本客户风险评估问卷的时候向本公司提出问题及索取独立意见。当完成本客户风险评估问卷并获评定风险取向及风险承担后，相关的资料会被记录于本公司并用于提供投资建议和评估该投资者是否适合相关的投资产品或服务。本公司将按照本客户风险评估问卷所提供资料作出评估，如其中的资料包含重大遗漏、错误或虚假陈述，本公司谨此免除就所有相关索赔、要求及诉讼承担责任。',
  description3: '假如我们向阁下招揽销售或建议任何金融产品，该金融产品必须是我们经考虑阁下的财政状况、投资经验及投资目标后而认为合理地适合阁下的。本协议的其他条文或任何其他我们可能要求阁下签署的文件及我们可能要求阁下作出的声明概不会减损本条款的效力。',
  btnReEvaluate: '重新测评'
}
